import { render, staticRenderFns } from "./use.vue?vue&type=template&id=54bc6827"
import script from "./use.vue?vue&type=script&lang=js"
export * from "./use.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports